import { Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    title: "1. Token amount — 100% refundable",
    body: "IshuKart pre-booking token ₹10,000 है, जो हमेशा 100% refundable रहता है। आप किसी भी समय, किसी भी वजह से अपनी booking cancel कर सकते हैं और पूरा token वापस पाने का हक रखते हैं — बशर्ते delivery scheduling process शुरू न हुआ हो।",
  },
  {
    title: "2. Cancellation कैसे करें",
    body: "support@ishukart.com पर email करें और अपना booking reference (जैसे ISH-XXXXXX) लिखें। हम आपकी cancellation confirm करके refund process शुरू कर देंगे। Cancellation request में कोई fee नहीं है।",
  },
  {
    title: "3. Refund timeline",
    body: "Cancellation confirm होने के बाद refund 7–10 business days में आपके original payment method पर वापस आ जाता है। Refund उसी method से जाता है जिससे payment किया गया था (UPI, card, netbanking — Razorpay के ज़रिए)। Bank की processing के कारण कभी-कभी 2–3 दिन अतिरिक्त लग सकते हैं।",
  },
  {
    title: "4. Failed payments",
    body: "अगर payment fail हो गया लेकिन आपके account से पैसे कट गए हों, तो Razorpay इसे automatically 5–7 business days में reverse कर देता है। ऐसा होने पर हमें email करें — हम payment gateway से status confirm करवा देंगे।",
  },
  {
    title: "5. Non-refundable situations",
    body: "Delivery schedule confirm होने और आपकी सहमति के बाद cancellation पर token refund नहीं मिलता — क्योंकि उस समय आपकी कार production queue में allocate हो चुकी होती है। यह condition आपसे पहले लिखित में confirm की जाती है।",
  },
  {
    title: "6. संपर्क और शिकायत",
    body: "Refund की स्थिति में किसी भी दिक्कत के लिए support@ishukart.com पर email करें — अपना booking reference के साथ। हम 48 घंटे के अंदर जवाब देने के लिए प्रतिबद्ध हैं।",
  },
];

export default function RefundPolicy() {
  return (
    <div className="mx-auto max-w-3xl px-5 pb-24 pt-40 sm:px-8" data-testid="refund-policy-page">
      <Reveal className="text-center">
        <p className="eyebrow">Legal</p>
        <h1 className="mt-4 font-display text-4xl font-extrabold uppercase text-white sm:text-5xl">
          Refund <span className="text-gold-gradient">Policy</span>
        </h1>
        <p className="mt-4 text-xs uppercase tracking-[0.2em] text-neutral-500">Last updated: October 2026</p>
      </Reveal>

      <div className="mt-14 space-y-5">
        {SECTIONS.map((s) => (
          <Reveal key={s.title}>
            <div className="rounded-2xl border border-white/10 bg-[#0a0a0e] p-7">
              <h2 className="font-display text-lg font-bold uppercase text-white">{s.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-neutral-400">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
